<template>
    <div class="jo-highlight" id="highlight">
      <h2 v-if="lang == 'zh'">要点</h2>
      <h2 v-else>High lights</h2>
      <div v-for="item in abstracts" v-if="item.lang == lang">
        <div v-for="item2 in item.data" class="highlight-content">
          <span class="mark">●</span>
          <p v-if="item2.name == 'p'">
            <component :is="'jo' + item3.name" v-for="item3 in item2.data"  v-bind:key="item3.index" v-bind:data="item3.data"></component>
          </p>
          <p v-else-if="item2.name == 'sec'">
            <span v-for="item3 in item2.data">
              <span v-if="item3.name == 'sectitle'">
                <component :is="'jo' + item4.name" v-for="item4 in item3.data.label"  v-bind:key="item4.index" v-bind:data="item4.data"></component>
              </span>
              <span v-else-if="item3.name == 'p'">
                <component :is="'jo' + item4.name" v-for="item4 in item3.data"  v-bind:key="item4.index" v-bind:data="item4.data"></component>
              </span>
              <component v-else :is="'jo' + item3.name"  v-bind:key="item3.index" v-bind:data="item3.data"></component>
            </span>
          </p>
          <component v-else :is="'jo' + item2.name" v-bind:key="item2.index" v-bind:data="item2.data"></component>
        </div>
      </div>
      <div v-if="abstracts.length==1 && abstracts[0].lang !== lang || abstracts.length<1">
        <p>{{lang=='en'? 'None' : '无'}}</p>
      </div>
    </div>
</template>

<script>
    export default {
      data() {
          return {
            lang: this.ARTICLE.defaultlang,
            abstracts: this.ARTICLE.highlights
          }
      },
      mounted(){
      },
      activated() {
        this.$bus.on('currentLang', (lang) => {
          this.lang = lang;
        })
      }

    }
</script>

<style lang="scss" scoped>
    .jo-highlight {
      h2 {
        background: none;
        color: #333;
      }
      .highlight-content{
        display: flex;
        margin-bottom: 1rem;
        padding-left: 2rem;
        .mark{
          color: #43a1a9;
          display: block;
          margin-top: 5px;
          margin-right: 5px;
          width: 10px;
          float: left;
        }
        p{
          text-indent: 0;
          margin-bottom: 0;
        }
      }
    }

</style>



// WEBPACK FOOTER //
// src/components/maincontent/body/highlight/highlight.vue